import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { IMAGES } from '../utils/images';
import { Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9, Step10, Step11, Step12, Step13, Step14 } from '../components/SurveySteps';


const steps = [Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9, Step10, Step11, Step12, Step13, Step14];

const EquipmentRentals = () => {
    const [surveyStarted, setSurveyStarted] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    // Form state: store answers keyed by step number or question key
    const [formData, setFormData] = useState({});

    const nextStep = () => setCurrentStep(prev => prev + 1);
    const previousStep = () => setCurrentStep(prev => prev - 1);

    // Update answer for a step
    const setAnswer = (key, value) => {
        setFormData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const getImageHeightClass = () => {
        // Survey not started
        if (!surveyStarted) return "md:h-[520px]";

        // Survey started but not stepped in yet
        if (surveyStarted && currentStep === 0) return "md:h-[500px]";

        // Steps start from 1
        if (currentStep === 1 || currentStep === 2) return "md:h-full";

        if (currentStep === 3 || currentStep === 4) return "md:h-[550px]";

        if (currentStep === 5 || currentStep === 6) return "md:h-full";

        if (currentStep === 7 || currentStep === 8) return "md:h-[560px]";

        if ([9, 10, 11].includes(currentStep)) return "md:h-[550px]";

        if (currentStep === 12) return "md:h-[560px]";

        if (currentStep === 13) return "md:h-[550px]";

        // Thank you / last screen
        return "md:h-full";
    };



    const renderRightBox = () => {
        if (!surveyStarted) {
            return (
                <div className="flex flex-col items-start gap-3">
                    <h2 className="text-white bg-secondary text-[14px] font-semibold custom-font px-3 py-2 rounded-full">
                        Equipment Rentals
                    </h2>
                    <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                        Get access to the best deals In office automation machines
                    </h2>

                    <p className="text-gray-700 text-[18px] leading-relaxed mb-4 mt-6">
                        We’ve partnered with{" "}
                        <span className="font-semibold">OxBow Technology Solutions</span>, one of Africa’s leading providers of professional printing equipment, to offer{" "}
                        <span className="font-semibold">SignetPrint</span> users exclusive access to printer rental solutions. Complete the short survey here and the Oxbow team will contact you directly, referencing Signet, to recommend the most suitable equipment for your business.
                    </p>

                    <button
                        className="btn-primary text-white mt-6 px-6 py-3 rounded-xl font-semibold w-full md:w-auto"
                        onClick={() => setSurveyStarted(true)}
                    >
                        Take Survey
                    </button>
                </div>
            );
        }

        if (surveyStarted && currentStep === 0) {
            return (
                <div className="flex flex-col items-center justify-center h-full gap-6 text-center">
                    <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font">
                        Begin Survey
                    </h2>
                    <button
                        className="btn-primary text-white px-6 py-3 rounded-xl font-semibold md:w-auto w-full"
                        onClick={() => setCurrentStep(1)}
                    >
                        Start
                    </button>
                </div>
            );
        }

        const StepComponent = steps[currentStep - 1];
        return StepComponent ? (
            <StepComponent
                nextStep={nextStep}
                previousStep={previousStep}
                formData={formData}
                setAnswer={setAnswer}
            />
        ) : (
            <div className="flex flex-col items-center justify-center h-full text-center">

                <p className="text-[#013135] text-[14px] flex items-center gap-2 mb-6 bg-[#F4F7F7] px-4 py-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="11" stroke="#013135" stroke-width="2" fill="none" />
                        <path d="M7 13l3 3 7-7" stroke="#013135" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    SignetPrint Partnership Referral Code:<span className="font-semibold">#12NV12</span>
                </p>

                <h2 className="text-[#0A0A0A] font-20 md:text-[35px] font-bold custom-font">
                    Thanks for the Enquiry!
                </h2>
                <p className="text-[#0A0A0A] text-[18px] leading-relaxed mb-4">
                    The team at Oxbow will be in touch shortly!
                </p>

                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={() => {
                        setSurveyStarted(false);
                        setCurrentStep(0);
                        setFormData({});
                    }}
                >
                    Exit
                </button>
            </div>
        );
    };

    return (
        <div className="bg-background">
            <NavBar />
            <div className="relative isolate min-h-screen px-5 pt-8 md:px-12 lg:px-16">
                <div className="py-16 sm:py-24">
                    <div className="bg-secondary rounded-xl mt-10 p-6 md:p-10 mx-0 md:mx-0 lg:mx-16">
                        <div className="flex flex-col lg:flex-row gap-10 lg:gap-8">

                            {/* LEFT SIDE - IMAGE */}
                            <div className="lg:w-2/5 order-2 lg:order-1 flex">
                                <img
                                    src={IMAGES.equipmentRentals}
                                    alt="Equipment Rentals"
                                    className={`w-full h-96 ${getImageHeightClass()} object-cover rounded-lg transition-all duration-300`}
                                />
                            </div>

                            {/* RIGHT SIDE - FORM / Survey */}
                            <div className="lg:w-3/5 order-1 lg:order-2 bg-white rounded-xl p-6 md:p-8 flex flex-col justify-center">
                                {renderRightBox()}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
export default EquipmentRentals;
